import { getImageSRC } from "../../../functions/assets";
import { getTimeFromNow } from "../../../functions/time";

export const getCardHeader = (item, attachments) => {
  const firstImage = getFirstImage(attachments);
  return {
    title: item.subject,
    ...(firstImage && { ...firstImage }),
    subheader: item.anonymous
      ? getTimeFromNow(item.createdAt)
      : `${item.author} ${getTimeFromNow(item.createdAt)}`,
  };
};

const getFirstImage = (attachments) => {
  if (attachments && attachments[0]) {
    const file = attachments[0];
    return {
      preview: `${getImageSRC(file.previewFilename)}&scalePercent=100`,
      src: getImageSRC(file.filename),
    };
  }
};
